import { format } from 'date-fns';

export const DISPLAY_DATE_SHORT_FORMAT = 'MM/yy';
export const DISPLAY_DATE_FORMAT = 'MMM d, yyyy';

export const formatDate = (formatString: string = DISPLAY_DATE_FORMAT) => {
  return (date: Date) => format(date, formatString);
};

export const formatTimestamp = (formatString: string = DISPLAY_DATE_FORMAT) => {
  return (timestamp: string | number) => format(new Date(Number(timestamp) * 1000), formatString);
};
